export default __webpack_public_path__ + "static/media/mr-management-icon.6c0afcc1.svg";